// The light/dark switch. @vowric/ui's tokens.css already expresses both
// themes; all this does is tell it which one, by stamping data-theme on the
// root element (its `:root[data-theme="…"]` blocks are what win over the
// prefers-color-scheme default).
//
// DARK IS THE DEFAULT, deliberately: this app was dark-only until C1, and a
// returning operator opening it to a white screen because their OS happens to
// prefer light would be a surprise nobody asked for. A stored choice wins;
// absent one, dark — the system preference is never consulted for the app
// shell. Applied at app start rather than in the operator shell so the portal
// routes (which render before any shell exists) get the same answer.
//
// Deliberately free of any @vowric/ui import: a theme is an attribute, not a
// material, so this module stays outside the chassis boundary ce1c3046 draws
// and can safely be reached from anywhere, portals included.
export type Theme = 'dark' | 'light';

const THEME_STORAGE_KEY = 'vowric_theme';

export function storedTheme(): Theme {
  try {
    return window.localStorage.getItem(THEME_STORAGE_KEY) === 'light' ? 'light' : 'dark';
  } catch {
    // localStorage unavailable (private-browsing edge cases) — dark, as ever.
    return 'dark';
  }
}

export function applyTheme(theme: Theme = storedTheme()): void {
  document.documentElement.dataset.theme = theme;
}

export function setTheme(theme: Theme): void {
  try {
    window.localStorage.setItem(THEME_STORAGE_KEY, theme);
  } catch {
    // Not persisted; still applied for this session.
  }
  applyTheme(theme);
}
